//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
import debounce from 'lodash.debounce'


// TODO: stop replacing <br> with a newline


function calcSpanLines(el, classSelector, noStartingSpace, fontScale)
{
	if (!el || !el.childNodes)	return [];

	// options = options || {};
	// options = {
	// 	wordClass : 'word',
	// 	// charClass: 'chr',
	// 	charClass: null,  // set charClass to split characters as well
	// 	charWrapper: null, // set charWrapper to wrap character that were split into a wrapper
	// 	...options
	// };

	var parentRect = el.getBoundingClientRect();

	function loopThroughNodes(childNodes, fontScale, removeSpace, parentLineChar, parentLineY)
	{
		parentLineChar = parentLineChar || 0;
		parentLineY = typeof parentLineY != 'undefined' ? parentLineY : -999999;
		fontScale = fontScale || 0.7;
		// let html = '';
		let lines = [];
		let lineY = [];
		let line = '';
		let lineChar = parentLineChar;
		var lastY = parentLineY;//-999999;

		// debugger

		for (var i = 0; i < childNodes.length; i++)
		{
			let node = childNodes[i];

			if (node.localName=='br')
			{
				let rect = node.getBoundingClientRect();

				// node.setAttribute('data-top', rect.top);
				// var fontSize = parseFloat( window.getComputedStyle(node).getPropertyValue('font-size') || 0 ) * 1;
				// if (line)
				// {
				// 	// line = '<span class="line">' + line + '</span>';
				// 	// if (this.wrapLines)
				// 	// 	line = '<span class="line-wrap">' + line + '</span>';
				// 	if ( !(lines.length==0 && line.length == 0) )
				// 	{
				// 		lines.push(line);
				// 		lineY.push(rect.top - parentRect.top);
				// 		line = '';
				// 	}
				// }
				lastY = rect.top - parentRect.top;
			}
			else if ( node.nodeType==3 /*TEXT_NODE*/
					|| (node.localName=='span' && node.classList.contains(classSelector))
					)
			{

				let rect = node.getBoundingClientRect();
				var fontSize = parseFloat( window.getComputedStyle(node).getPropertyValue('font-size') || 0 ) * fontScale;
				// consola.debug(`"${node.textContent}" fontsize[${fontSize}] lastY[${lastY}] top[${(rect.top - parentRect.top)}]`, fontSize);
				// this assumes that spaces have "white-space: pre", otherwise they have zero size
				// node.setAttribute('data-top', rect.top);

				// if scrolling when the node.getBoundingClientRect() is called the result is flaky
				// so we use the difference from the fontSize to produce a reliable result
				if ( Math.abs( (rect.top - parentRect.top) - lastY) > fontSize )
				{
					// line = '<span class="line">' + line + '</span>';
					// if (this.wrapLines)
					// 	line = '<span class="line-wrap">' + line + '</span>';
					if ( !(lines.length==0 && line.length == 0) )
					{
						lines.push(line);
						lineY.push(rect.top - parentRect.top);
						line = '';
					}
					lineChar = 0;//parentLineChar;
				}
				lastY = rect.top - parentRect.top;
				// consola.debug(`[font: ${fontSize}] [prnt: ${parentRect.top}] [y: ${rect.top}] [yDiff: ${lastY}] ${node.textContent}`);

				// if the 1st char of a line is space ignore it
				// if (line.length==0 && node.textContent.trim().length==0)	continue;

				// debugger;
				if (removeSpace && line.length == 0 && lineChar==0 && lastY!=parentLineY)
				{
					if ( (node.textContent || '').trim().length == 0 )
					{
						continue; // ignore white space at the beginning of the line
					}
				}

				// debugger;
				let tempNode = node.cloneNode();
				tempNode.innerHTML = node.innerHTML;
				tempNode.classList.add( 'line-' + classSelector + '-' + (++lineChar) )


				// if ( typeof (tempNode.outerHTML || tempNode.textContent)=='undefined' )
				// {
				// 	debugger;
				// }

				if (this.wrapChars && this.splitChars)
				{
					line += `<span class="chrWrp">` + (tempNode.outerHTML || tempNode.textContent) + '</span>';
				}
				else
				{
					line += tempNode.outerHTML || tempNode.textContent;
				}
			}
			else
			{
				let result = loopThroughNodes.call(this, node.childNodes, fontScale, removeSpace, lineChar, lastY);
				if ( result.lines.length==0 )
				{
					continue;
				}
				let childLines = result.lines;
				let childLinesY = result.lineY;
				let childLineChar = result.lineChar;

				let rect = node.getBoundingClientRect();
				var fontSize = parseFloat( window.getComputedStyle(node).getPropertyValue('font-size') || 0 ) * fontScale;

				// node.setAttribute('data-top', rect.top);

				if (node.hasAttributes() && node.attributes.getNamedItem('class'))
				{
					let classes = node.attributes.getNamedItem('class').textContent;
					for (let j = 0; j < childLines.length; j++)
					{
						childLines[j] = `<${node.localName} class="${classes}">${childLines[j]}</${node.localName}>`;
					}
				}
				else
				{
					for (let j = 0; j < childLines.length; j++)
					{
						childLines[j] = `<${node.localName}>${childLines[j]}</${node.localName}>`;
					}
				}


				// if (childLinesY[0] == lastY)
				if ( Math.abs( (rect.top - parentRect.top) - lastY) <= fontSize )
				{
					lastY = childLinesY.shift(); // remove the 1st element
					line += childLines[0];
					childLines.shift(); // remove the 1st element
				}
				// else
				// {
				// 	lineChar = 0;//parentLineChar;
				// }
					lineChar = childLineChar;
				if (childLines.length)
				{
					if ( !(lines.length==0 && line.length==0) )
					{
						lines.push(line);
						lineY.push(lastY);
						line = '';
						lineChar = 0;//parentLineChar;
					}
					lines = lines.concat(childLines);
					lineY = lineY.concat(childLinesY);

					line = lines.pop();
					lastY = lineY.pop();
					lineChar = childLineChar;
				}
				// lastY = lineY[lineY.length-1];
			}

		}	// for end

		if ( !(lines.length==0 && line.length == 0) )
		{
			lines.push(line);
			lineY.push(lastY);
		}
		return {lines, lineY, lineChar};
	}

	var ret = loopThroughNodes.call(this, el.childNodes, fontScale, noStartingSpace);
	return ret;

}


const nonLetterExpression = /[\s\n\\/\-\+:=#$%^&@]+/;

function checkIsSpace(chars, j, nonLetterExpr)
{
	var word = '';
	for (let i = j; i < chars.length; i++)
	{
		const ch = chars[i];
		if ( !nonLetterExpr.test(ch) )	break;
		if (ch != ' ')	break;

		word += ch;
	}

	if (word.length == 0)	return false;
	if (word.trim().length == 0)	return true;
	return false;
}


function splitHtml(childNodes, options)
{
	options = options || {};
	options = {
		wordClass : 'word',
		// charClass: 'chr',
		charClass: null,  // set charClass to split characters as well
		charWrapper: null, // set charWrapper to wrap character that were split into a wrapper
		// nonLetterExpr: /[\s\n\\/\-\+\*:=#$%^&@]+/,
		nonLetterExpr: nonLetterExpression,
		...options
	};

	function splitText(textContent, wordCount, charCount)
	{
		var html = '';
		var chars = textContent.split('');

		charCount = charCount || 1;
		wordCount = wordCount || 1;

		var currentWord = '';

		// var words = [];
		// var word = options.charClass ? [] : '';

		var prevChar = '\n';
		// for (var ch of chars)
		for (let i = 0; i < chars.length; i++)
		{
			const ch = chars[i];

			if ( options.nonLetterExpr.test(ch) )
			{
				// debugger;
				if ( options.nonLetterExpr.test(prevChar)==false || ch == '\n')
				{
					html += '</span>';
					currentWord = '';

					// if (word)	words.push(word);
					// word = options.charClass ? [] : '';
				}
				if (ch == '\n')
				{
					html += '</span><br>';
					currentWord = '';

					// if (word)	words.push(word);
					// words.push('\n');
					// word = options.charClass ? [] : '';
				}
				else
				{
					if ( options.nonLetterExpr.test(prevChar)==false || prevChar == '\n')
					{
						const isEmpty = checkIsSpace(chars, i, options.nonLetterExpr);
						html += `<span class="${options.wordClass} ${isEmpty ? options.wordClass+'-space' : ''}">`;
						currentWord = '';
					}

					// if (options.charWrapper && options.charClass)
					// 	html += `<span class="${options.charWrapper} ${options.charWrapper + charCount}">`;
					if (options.charClass)
					{

						html += `<span class="${options.charClass} ${options.charClass + charCount} ${ch==' ' ? options.charClass+'-space' : ''}">${ch}</span>`;
					}
					else
					{
						html += ch;
					}
					currentWord += ch;
					// if (options.charWrapper)	html += `</span>`;
					charCount++;

					// if (options.charClass)	word.push(ch);
					// else					word +=  ch;
				}
			}
			else
			{
				if ( options.nonLetterExpr.test(prevChar) )
				{
					if (prevChar != '\n')
					{
						html += '</span>';
					}
					html += `<span class="${options.wordClass} ${options.wordClass + wordCount}">`;
					currentWord = '';
					wordCount++;
					// if (word)	words.push(word);
					// word = options.charClass ? [] : '';
				}
				// if (options.charWrapper && options.charClass)
				// 	html += `<span class="${options.charWrapper} ${options.charWrapper + charCount}">`;
				if (options.charClass)
					html += `<span class="${options.charClass} ${options.charClass + charCount} ${ch==' ' ? options.charClass+'-space' : ''}">${ch}</span>`;
				else
					html += ch;
				currentWord += ch;
				// if (options.charWrapper)	html += `</span>`;
				charCount++;

				// if (options.charClass)	word.push(ch);
				// else					word +=  ch;
			}
			// if (ch != '\n')
				prevChar = ch;
		}	// for end
		// if (word)	words.push(word);
		// if ( options.nonLetterExpr.test(prevChar)==false )
		{
			html += '</span>';
		}

		// return words;
		return {html, wordCount, charCount};
	}

	function splitNodes(childNodes, wordCount, charCount)
	{
		let html = '';
		charCount = charCount || 1;
		wordCount = wordCount || 1;
		for (var i = 0; i < childNodes.length; i++)
		{
			let node = childNodes[i];
			if (node.nodeType == 3) // text node
			{
				let obj = splitText(node.textContent, wordCount, charCount);
				wordCount = obj.wordCount;
				charCount = obj.charCount;
				html += obj.html;
			}
			else if (node.nodeType == 1) // element node
			{
				if (node.localName=='br')
					html += `<${node.localName}/>`;
				else
				{
					let obj = splitNodes(node.childNodes, wordCount, charCount);
					wordCount = obj.wordCount;
					charCount = obj.charCount;
					html += `<${node.localName}>${obj.html}</${node.localName}>`;
				}
			}
		}
		return {html, wordCount, charCount};
	}

	var ret = splitNodes(childNodes);
	// debugger;
	return ret.html;

}


export default
{
	name: 'text-fx',
	props:
	{
		active:
		{
			type: Boolean,
			default: true,
		},
		noStartingSpace:
		{
			type: Boolean,
			default: true,
		},
		fontScale:
		{
			type:  Number,
			default: 0.7,
		},
		contentKey:
		{
			default: '',
		},
		splitChars:
		{
			type: Boolean,
			default: false,
		},
		wrapChars:
		{
			type: Boolean,
			default: false,
		},
		splitLines:
		{
			type: Boolean,
			default: true,
		},
		wrapLines:
		{
			type: Boolean,
			default: false,
		},
		classOnLoad:
		{
			type: String,
		},
		// classOnLeave:
		// {
		// 	type: String,
		// },
		options:
		{
			type: Object,
			default: () => ({})
		}
	},
	data()
	{
		return {
			loaded: false,
			// splitTextParts: [],
			splitTextHtml: '',
			lines: [],
			resizeHandler: null,
			_options: {},
		}
	},

	mounted()
	{
		// consola.debug('text-fx mounted is ', this.$el);
		// consola.debug('text-fx has slot ', this.$slots.default);
		// consola.debug('text-fx has text ', this.text);



		this.onContentChange();
	},
	beforeDestroy()
	{
		if (this.active)
			if (typeof window !== 'undefined')
			{
				window.removeEventListener('resize', this.resizeHandler);
			}
	},

	watch:
	{
		active(newVal)
		{
			if (newVal)
			{
				this.initTextSplit()
			}
			else
			{
				this.removeTextSplit()
			}
		},

		contentKey(newVal)
		{
			this.$nextTick( ()=>
			{
				this.onContentChange(0);
			} )
		}
	},
	computed:
	{
		// text()
		// {
		// 	return (this.$refs.initial.innerHTML || this.$refs.initial.innerText || this.$refs.initial.textContent || '').trim().replace(/<br>/g, '\n');
		// 	// return this.$el.innerText || this.$el.textContent;
		// },
		itemClass()
		{
			return this.splitChars ? 'chr' : 'word';
		},

		extraClasses()
		{
			return this.loaded ? this.classOnLoad : null;
		}
	},
	methods:
	{
		onContentChange(classDelay)
		{
			classDelay = classDelay || 500;
			this.splitTextHtml = '';
			this.lines = [];

			this._options =
			{
				selector: '',
				from: null,
				to: null,
				duration: 0,
				stagger: 0,
				ease: null,
				onComplete: null,
				...this.options
			};

			this.loaded = false;
			if (this.active)
			{
				this.initTextSplit()
			}

			this.$nextTick( ()=>
			{
				setTimeout( ()=>
				{
					// consola.debug('text-fx loaded')
					this.loaded = true;
				}, classDelay )
			} )
			this.$emit('load');
		},

		initTextSplit()
		{
			// if (this.splitTextParts.length == 0)
			// 	this.splitTextParts = splitHtml(this.text, {});
			if (this.splitTextHtml.length == 0)
			{
				let options = {};
				if (this.splitChars)	options.charClass = 'chr';
				if (this.wrapChars)		options.charWrapper = 'chrWrp';
				this.splitTextHtml = splitHtml(this.$refs.initial.childNodes, options);
			}
			// consola.debug('splitTextParts: ', this.splitTextParts);

			this.$nextTick( ()=>
			{
				setTimeout( ()=>
				{
					this.recalcLines();
					if (this._options.selector && this._options.from)
					{
						TweenLite.set(	this.$el.querySelectorAll(this._options.selector),
										this._options.from);
					}
				}, 50); // needs a small delay so that the browser can have time to re-layout
			 } )

			this.resizeHandler = debounce( () => this.recalcLines(), 150);
			if (typeof window !== 'undefined')
			{
				window.addEventListener('resize', this.resizeHandler);
			}
		},

		removeTextSplit()
		{
			this.lines = [];
			// this.splitTextParts = [];
			this.splitTextHtml = '';
			if (typeof window !== 'undefined')
			{
				window.removeEventListener('resize', this.resizeHandler);
			}
		},

		recalcLines()
		{
			var html = '';
			// var lines = calcSpanLines(this.$refs.split, (this.splitChars ? '.chr' : '.word'));
			// this.lines = lines;

			var { lines, /*linesY*/ } = calcSpanLines.call(this, this.$refs.split, (this.splitChars ? 'chr' : 'word'), this.noStartingSpace, this.fontScale);
			this.lines = lines;

			// consola.debug('lines: ', lines)

			// var text = lines.map( (x) => x.join('') ).join('').trim();
			// consola.debug(`recalc [lines: ${lines.length}] of "${ text }"`);

			// if (lines.length > 3)
			// {
			// 	return false;
			// }

			// if (!text)
			// {
			// 	consola.debug('no text to recalc');
			// 	return;
			// 	// debugger;
			// }

			// html = el.querySelector('.text-fx-wrapper .invisible').outerHTML;

			// html += '<span class="line-wrapper">';
			// html += lines.map( (x) => `<span class="line"><span class="chrWrp"><span class="chr">${x.join('</span></span><span class="chrWrp"><span class="chr">')}</span></span></span><br/>` ).join('');
			// html += '</span>';

			// el.querySelector('.text-fx-wrapper').innerHTML = html;
			// $(el).find('.chr').each( (idx, el) => { $(el).addClass('chr'+(idx + 1)) });
			// $(el).addClass('text-fx-processed');
		}
	},
}
